import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.6 2.667a.667.667 0 0 0-1.333 0V8A.667.667 0 0 0 8.6 8z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M5.03 4.51a.667.667 0 0 0-.86-1.02 5.833 5.833 0 1 0 7.527 0 .667.667 0 0 0-.86 1.02 4.5 4.5 0 1 1-5.807 0"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })